import ActorMetric from './ActorMetric';

export default ActorMetric;
